var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow",
    width: "25px",
    height: "22px",
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arrow-1",
    d: "M13.25,0 L24,10.75 L13.25,21.5 L5.5,21.5 L13.686,13.5 L0,13.5 L0,8 L13.686,8 L5.5,0 L13.25,0 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-3",
    transform: "translate(-276.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-6",
    transform: "translate(272.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-7",
    transform: "translate(4.500000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "arrow-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "arrow-9",
    xlinkHref: "#arrow-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrow-10",
    className: "fill-selector",
    fill: "#151515",
    xlinkHref: "#arrow-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9441ada69db748d9c22447e2c92a2ec2.svg";
export { ForwardRef as ReactComponent };